<template>
  <div>
    <v-btn
      v-if="type === 'button'"
      depressed
      small
      tile
      color="grey lighten-3"
      :disabled="editingItemIndex != null"
      @click="addNewItem(variety, options, previousIndex)"
    >
      <div v-if="mdiIcon">
        <v-icon>
          {{ mdiIcon }}
        </v-icon>
      </div>
      <div v-else>
        {{ varietyName }}
      </div>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { defaultValue as htmlTableItemValue } from '@/components/postEditor/items/HtmlTableItem/HtmlTableItemDefaultValues'

export default {
  name: 'ItemAddBtn',
  props: {
    variety: {
      type: String,
      required: true
    },
    varietyName: {
      type: String,
      required: true
    },
    mdiIcon: {
      type: String,
      required: false,
      default: null
    },
    options: {
      type: Object,
      required: true
    },
    previousIndex: {
      type: Number,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      editingItemIndex: (state) => state.PostEditor.editingItemIndex
    })
  },
  methods: {
    addNewItem (variety, options, previousIndex) {
      let newIndex
      if (previousIndex == null) {
        newIndex = 0
      } else {
        newIndex = previousIndex + 1
      }
      const payload = {
        index: newIndex,
        item: {
          id: null,
          variety: variety,
          order: null,
          _destroy: false,
          newItem: true,
          itemableAttributes: itemableAttributesTemplate(variety, options)
        }
      }
      this.$store.commit('PostEditor/ADD_NEW_ITEM', payload)
    }
  }
}

const itemableAttributesTemplate = (variety) => {
  if (variety === 'heading') {
    return {
      content: '',
      headingType: ''
    }
  } else if (variety === 'text') {
    return {
      content: ''
    }
  } else if (variety === 'point') {
    return {
      title: '',
      content: ''
    }
  } else if (variety === 'image') {
    return {
      altAttribute: '',
      imagableId: null,
      imagableType: null,
      heading: null,
      content: null,
      quoteUrl: null
    }
  } else if (variety === 'external_link') {
    return {
      style: 'normal',
      url: '',
      sentence: '',
      description: null
    }
  } else if (variety === 'list') {
    return {
      style: 'ordered',
      title: '',
      items: ['']
    }
  } else if (variety === 'quotation') {
    return {
      content: '',
      source: '',
      sourceUrl: null
    }
  } else if (variety === 'internal_link') {
    return {
      targetPost: null,
      targetPostId: null
    }
  } else if (variety === 'embedding') {
    return {
      variety: null,
      content: null,
      data: null,
      url: null,
      description: null
    }
  } else if (variety === 'product') {
    return {
      name: null,
      alternateName: null,
      price: null,
      description: null,
      officialUrl: null,
      amazonUrl: null,
      rakutenUrl: null,
      otherUrl: null,
      otherUrlSentence: null,
      quoteUrl: null,
      downloadImageId: null,
      downloadImageUrl: null,
      taxIncluded: true,
      productImageDirectUrl: null
    }
  } else if (variety === 'html') {
    return {
      content: null
    }
  } else if (variety === 'character') {
    return {
      content: null,
      imageSide: 'left',
      characterImageId: null,
      characterImage: null
    }
  } else if (variety === 'table_item') {
    return {
      tableContent: {}
    }
  } else if (variety === 'button') {
    return {
      type: 'rectangle',
      sizeType: '',
      url: '',
      content: '',
      labelText: '',
      fontSize: 14,
      fontColor: '#ffffff',
      backgroundColor: '#315ED9',
      radius: '0'
    }
  } else if (variety === 'banner') {
    return {
      url: '',
      maxWidth: '',
      boxShadow: {
        x: null,
        y: null,
        spread: null,
        blur: null
      },
      topLabel: {
        content: '',
        size: null,
        color: ''
      },
      bottomLabel: {
        content: '',
        size: null,
        color: ''
      },
      imagableId: null,
      imagableType: null,
      imageDirectUrl: null
    }
  } else if (variety === 'html_table') {
    return {
      tableColumnFixed: -1,
      scrollable: false,
      htmlTableContent: [
        [htmlTableItemValue(), htmlTableItemValue()],
        [htmlTableItemValue(), htmlTableItemValue()]
      ]
    }
  } else {
    return {}
  }
}
</script>

<style scoped></style>
